import React from "react";
import { makeStyles, Button, Box } from "@material-ui/core";
import InputTextField from "components/input/inputTextField";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "9fr 2fr 2fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  button: {
    [theme.breakpoints.up("sm")]: {
      width: "fit-content",
      justifySelf: "flex-end",
    },
  },
  inputRoot: {
    marginTop: "5px",
  },
  input: {
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  checkboxRoot: {
    display: "flex",
    justifyContent: "center",
    margin: 0,
  },
}));

export default function ParticipantSearchComponent({
  handleSearch,
  isFetching,
  lang,
  search,
  setSearch,
}) {
  const classes = useStyle();

  return (
    <Box p={2} mb={1} className={classes.searchContainer}>
      <InputTextField
        variant="filled"
        value={search}
        className={classes.inputRoot}
        size="small"
        placeholder={getLang(lang, "placeholder.SEARCH")}
        margin="none"
        InputProps={{
          disableUnderline: true,
          margin: "none",
          style: {
            borderRadius: "4px",
            backgroundColor: "#ECEFF0",
          },
          classes: { input: classes.input },
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !isFetching) handleSearch(search);
        }}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      <Button
        color="primary"
        variant="text"
        size="small"
        disableElevation
        disabled={isFetching}
        onClick={() => {
          setSearch("");
          handleSearch("");
        }}
      >
        {getLang(lang, "label.CLEAR")}
      </Button>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        type="submit"
        size="small"
        disabled={isFetching}
        onClick={() => handleSearch(search)}
      >
        {getLang(lang, "label.SEARCH")}
      </Button>
    </Box>
  );
}
